// src/components/SubLayout.jsx
import { useLocation } from "react-router-dom";

export default function SubLayout({ data, heroBg, title, children }) {
  const { pathname } = useLocation();

  const sectionKey =
    pathname.startsWith("/instructors") ? "instructors" :
    pathname.startsWith("/partners")    ? "partners"    :
    pathname.startsWith("/centers")     ? "centers"     :
    "about";

  const resolvedHero =
    heroBg || data?.[sectionKey]?.hero || data?.hero?.bg ||
    "https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=2070&q=80";

  return (
    <div className="about-page">
      {/* 히어로: 제목만 */}
      <section className="about-hero" style={{ backgroundImage: `url('${resolvedHero}')` }}>
        <div className="container">
          <h1>{title || "페이지"}</h1>
          <div className="hero-underline" />
        </div>
      </section>

      {/* 본문 */}
      <main>{children}</main>
    </div>
  );
}
